module.exports = __webpack_public_path__ + "static/media/sunCloudy.cad32ce5.png";